import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const assignmentErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  419: {
    title: 'Niedostępne',
    detail: 'Zadanie jest poza okienkiem dostępności czasowej.',
  },
  [ErrorCodes.NOT_FOUND.ASSIGNMENT]: {
    title: 'Zadanie nie znalezione',
    detail: 'Nie znaleziono zadania o podanym identyfikatorze.',
  },
  [ErrorCodes.NOT_FOUND.ASSIGNMENT_RESPONSE]: {
    title: 'Odpowiedź nie znaleziona',
    detail: 'Nie znaleziono odpowiedzi o podanym identyfikatorze.',
  },
  [ErrorCodes.NOT_FOUND.QUIZ]: {
    title: 'Quiz nie znaleziony',
    detail: 'Powiązany quiz nie istnieje.',
  },
  [ErrorCodes.FORBIDDEN.ASSIGNMENT.NOT_ASSIGNED]: {
    title: 'Brak dostępu',
    detail: 'To zadanie nie zostało Ci przypisane.',
  },
  [ErrorCodes.FORBIDDEN.ASSIGNMENT.NOT_OWNER]: {
    title: 'Brak uprawnień',
    detail: 'Możesz edytować tylko własne odpowiedzi.',
  },
  [ErrorCodes.FORBIDDEN.ASSIGNMENT.OUTSIDE_AVAILBILITY]: {
    title: 'Zadanie niedostępne',
    detail: 'Zadanie jest poza okienkiem dostępności czasowej.',
  },
  [ErrorCodes.FORBIDDEN.ASSIGNMENT.EXCEEDED_MAX_ATTEMPTS]: {
    title: 'Przekroczono limit prób',
    detail: 'Wykorzystano maksymalną liczbę prób dla tego zadania.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.ASSIGNMENT_IS_QUIZ]: {
    title: 'Zadanie typu quiz',
    detail: 'Nie można dodać tekstowej odpowiedzi do zadania powiązanego z quizem.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.DUPLICATE_SUBMISSION]: {
    title: 'Odpowiedź już istnieje',
    detail: 'Dla tego zadania istnieje już zapisana odpowiedź.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.ASSIGNMENT_FEEDBACK]: {
    title: 'Niepoprawna informacja zwrotna',
    detail: 'Nie udało się zapisać informacji zwrotnej. Sprawdź wprowadzone dane.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.ASSIGNMENT_FEEDBACK_FILE]: {
    title: 'Niepoprawna informacja zwrotna',
    detail: 'Komentarz dotyczy pliku, który nie należy do tej odpowiedzi.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.OVERDUE_AND_CURRENT_CONFLICT]: {
    title: 'Sprzeczne filtry',
    detail: 'Filtry „tylko zaległe” i „tylko aktualne” nie mogą być włączone jednocześnie.',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.INVALID_PAGINATION_DATE]: {
    title: 'Niepoprawna data',
    detail: 'Podana data filtra jest niepoprawna.',
  },
};
